const regex = new RegExp('^[0-9]+$');
export const formatZip = (value: string) => {
    let zip = value;
    if (value && regex.test(value) && value.length > 5) {
        zip = zip.replace('-', '');
        zip = zip.substring(0, 5) + '-' + zip.substring(5, zip.length);
    }
    return zip;
};
